// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pe-6";
export var imgContainer = "_pe-3";
export var menuIcon = "_pe-5";
export var pillWrapper = "_pe-2";
export var pillsContainer = "_pe-1";
export var subscriptionCard = "_pe-0";
export var subscriptionLogo = "_pe-4";